import Abort from 'utils/abort'
import { sentryLog } from 'utils/sentryLogging'

const fetchUrl = async (url: string) => {
  try {
    await fetch(url, { signal: Abort.getInstance().signal })
  } catch (e) {
    const error = e as Error

    sentryLog(error, {
      url,
    })
  }
}

export default fetchUrl
